import styles from "./CreditForm.module.scss";
import primaryComponents from "../../primaryComponents";
import secondaryComponents from "../../secondaryComponents";
import useCreditForm from "./useCreditForm";
import Validation from "./Validation";
import { formatCurrency } from "../../../helpers";
import { useSelector } from "react-redux";

const CreditForm = ({
  invoiceDetails,
  billsDetails = null,
  supplierDetails = null,
  currencyCode,
  handleFetchInvoice = () => {},
  closeWidget = () => {},
}) => {
  const { currency_code: businessCurrencyCode } = useSelector(
    (state) => state.profileDetailsReducer.businessDetails,
  );
  const currency_code = currencyCode || businessCurrencyCode;

  const {
    isAddingCredit,
    creditDetails,
    isLoadingBankAccountsList,
    bankAccounts,
    setCreditDetails,
    submitCreditInfo,
  } = useCreditForm({
    invoiceDetails,
    handleFetchInvoice,
    closeWidget,
    billsDetails,
    supplierDetails,
  });
  const {
    handleSubmit,
    control,
    register,
    trigger,
    formState: { errors },
  } = Validation({ creditDetails });

  return (
    <div className={styles.creditForm}>
      <h5 className="font-weight-semibold">
        Invoice - <span className="purple--text">{invoiceDetails?.id}</span>
      </h5>

      <div className={styles.user_info}>
        <p className={styles.acct_text}>Outstanding Balance</p>
        <div className={styles.acct_no_wrapper}>
          <p className="purple--text">
            {formatCurrency({
              value: invoiceDetails?.outstanding_balance,
              currencyCode: currency_code,
            })}
          </p>
        </div>
      </div>
      <div className={styles.user_info}>
        <p className={styles.acct_text}>Total Credit:</p>
        <div className={styles.acct_no_wrapper}>
          <p>
            {formatCurrency({
              value: invoiceDetails?.credit_amount,
              currencyCode: currency_code,
            })}
          </p>
        </div>
      </div>
      <div className={styles.user_info}>
        <p className={styles.acct_text}>Total Repayment</p>
        <div className={styles.acct_no_wrapper}>
          <p>
            {formatCurrency({
              value: invoiceDetails?.total_repayment,
              currencyCode: currency_code,
            })}
          </p>
        </div>
      </div>

      {/* form section */}
      <form
        onSubmit={handleSubmit(submitCreditInfo)}
        className={`${styles.formSection} border rounded py-3 px-3 `}
      >
        {/* <primaryComponents.InputFieldV2
          control={control}
          classNames="white"
          name="outstandingBalance"
          label="Outstanding Balance"
          isDisabled={true}
          value={invoiceDetails?.outstanding_balance}
          register={register}
        /> */}
        <primaryComponents.AmountField
          control={control}
          classNames="white"
          name="amountPaid"
          label="Amount Paid"
          placeholder="Enter amount paid"
          isRequired={true}
          value={creditDetails?.amount_paid}
          onChange={({ target: { value } }) => {
            setCreditDetails((prev) => ({
              ...prev,
              amount_paid: value,
            }));
          }}
          errorMessage={errors.amountPaid}
          onKeyUp={() =>
            errors.amountPaid !== undefined && trigger("amountPaid")
          }
          register={register}
          currency_code={currency_code}
        />

        <primaryComponents.SelectFieldV2
          label="Payment Method"
          isRequired
          options={[
            { name: "Transfer", id: "transfer" },
            { name: "Card", id: "card" },
            { name: "Cash", id: "cash" },
            { name: "Cheque", id: "cheque" },
          ]}
          nameKey={"name"}
          idKey={"id"}
          name="paymentMethod"
          control={control}
          value={
            creditDetails?.payment_method
              ? creditDetails?.payment_method
              : "Select payment method"
          }
          errorMessage={errors.paymentMethod}
          onChange={(value) => {
            setCreditDetails((prevState) => ({
              ...prevState,
              payment_method: value,
            }));
          }}
        />

        <div className="mb-2">
          <secondaryComponents.LoaderHelper
            isLoading={isLoadingBankAccountsList}
            className="mt-1"
          >
            <primaryComponents.SelectFieldV2
              control={control}
              options={bankAccounts?.data?.map((bank) => ({
                id: bank?.id,
                name: bank?.account_label,
              }))}
              label={"Fund Supplier From"}
              name="ledgerAccount"
              idKey="id"
              nameKey="name"
              value={"Select Bank Account"}
              onChange={(value) => {
                setCreditDetails((prev) => ({
                  ...prev,
                  ledger_account_id: value,
                }));
              }}
              floatError={false}
              classNames="bank-name"
              isSearchable={false}
            />
          </secondaryComponents.LoaderHelper>
        </div>

        <div className="d-flex justify-content-between mt-3">
          <primaryComponents.Button
            classNames={"btn btn--primary cover"}
            isLoading={isAddingCredit}
            isDisabled={isAddingCredit}
            loadingText={"Updating..."}
          >
            {"Update"}
          </primaryComponents.Button>
        </div>
      </form>
    </div>
  );
};
export default CreditForm;
